// extracted by mini-css-extract-plugin
export default {"page":"MK","wrapper":"NK","text":"OK","icons":"PK","icon":"QK","icon_text":"RK","carousel_wrapper":"SK","slide":"TK","image":"UK","arrows":"VK","prev":"WK","modal_root":"XK","x_mark":"YK","modal":"ZK","images":"aL","main_image":"bL","name":"cL"};
    if(module.hot) {
      // 1721922364751
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  